import { useReducer } from 'react';
import { useCar } from './useCar';
import { useAuth } from '../providers/authProvider';


const useApp = (appReducer, initialAppState) => {
  const [appState, appDispatch] = useReducer(appReducer, initialAppState);

  const { carService } = useCar(-1);
  const auth = useAuth();

  const fetchData = (data, actionType) => {
    appDispatch({ type: actionType, data: data });
  };

  const setupDefault = () => {
 
  
    if (typeof auth !== 'undefined' && auth.isLoggedIn) {
     


      carService.fetchAppData().then(data => {

          
    

        fetchData(data.makers, 'SET_MAKERS');
        fetchData(data.models, 'SET_MODELS');
        fetchData(data.countries, 'SET_COUNTRIES');
        fetchData(data.cities, 'SET_CITIES');
        fetchData(data.websites, 'SET_WEBSITES');
        fetchData(data.agents, 'SET_AGENTS');
        fetchData(data.statuses, 'SET_STATUSES');
        fetchData(data.users, 'SET_SALERS');
        fetchData(data.dealers, 'SET_DEALERS');
        fetchData(data.marine_lines, 'SET_MARINE_LINES');
        fetchData(data.roles, 'SET_ROLES');
        fetchData(data.permissions, 'SET_PERMISSIONS');
        fetchData(data.all_permissions, 'SET_ALL_PERMISSIONS');
        fetchData(data.container_prices, 'SET_CONTAINER_PRICE');
        fetchData(data.calculator_prices, 'SET_CALCULATOR_PRICES');
        fetchData(data.prices, 'SET_PRICES');
        fetchData(data.companies, 'SET_COMPANIES');
        fetchData(data.shippers, 'SET_SHIPPERS');
        fetchData(data.user, 'SET_USER');


        const initialTypeOptions = [
          { value: 0, label: '------' },
          { value: 1, label: 'Სარკინიგზო' },
          { value: 2, label: 'კონტეინერ მზიდი' },
          { value: 3, label: 'Საცალო' },
        ];
        

  
        const container_statuses = [
          { id: 1, value: 1, label: "ახალი", color: "#ffb142" },
          { id: 3, value: 3, label: "შემოსული", color: "#6900c6" },  
          { id: 2, value: 2, label: "გახსნილი", color: "#00bcd4" },  
          { id: 4, value: 4, label: "არქივი", color: "#009688" },  
        ];
    

        const assign_container_statuses = [
          { id: 1, value: 1, label: "ახალი", color: "#ffb142" }, ,  
        ];

        if (data.permissions.some(permission => permission.name === "CONTAINER_STATUS_OPEN")) {
          assign_container_statuses.push({ id: 2, value: 2, label: "გახსნილი", color: "#00bcd4" });
        }
  
        if (data.permissions.some(permission => permission.name === "CONTAINER_STATUS_FINISH")) {
          assign_container_statuses.push({ id: 4, value: 4, label: "არქივი", color: "#009688" });
        }
        
        
        fetchData(container_statuses, 'SET_CONTAINER_STATUSES');
        fetchData(initialTypeOptions, 'SET_INITIALTYPEOPTIONS');

        fetchData(assign_container_statuses, 'SET_ASSIGN_CONTAINER_STATUSES');


        if (! data.permissions.some(permission => permission.name === "LIST_SHOW") ) {
          setIsTable(false)
        } else {
          const savedValue = localStorage.getItem('isTable'); 
          const newIsTable = (savedValue !== null) ? JSON.parse(savedValue) : true

          setIsTable(newIsTable)
        }

        setLoaded()
      })
    } else {

      console.log("ავტორიზაცია არ არის")
        
    }
  };

  const  hasPermission = (name) => {
    return appState.permissions.some(permission => permission.name === name);
  }
 
  const setIsTable = (isTable) => {
    appDispatch({ type: "SET_IS_TABLE", data: isTable });
  }

  const setIsTableRevert = () => {
    appDispatch({ type: "SET_IS_TABLE_REVERT"});
  }


  const setLoaded = () => {
    appDispatch({ type: "SET_IS_LOADED"});
  }

  const setError = (error) => {
    appDispatch({ type: "SET_ERROR", data: error });
  }

  const clearError = () => {
    appDispatch({ type: "SET_ERROR", data: null });
  }

  const setOk = (error) => {
    appDispatch({ type: "SET_OK", data: error });
  }

  const clearOk = () => {
    appDispatch({ type: "SET_OK", data: null });
  }

  const app = {
    setupDefault,
    setError, 
    setIsTable,
    setIsTableRevert,
    clearError,
    hasPermission,
    setOk,
    clearOk,
   };

  return [
    appState,
    app,
  ];
};

export default useApp;